import { getFeature } from 'Cloud/Application/FeaturesEs6';

interface FeatureProps {
    variant: 'a' | 'b' | 'c';
    tariff?: string;
}

// CLOUDWEB-18911
// Растяжка про оверквоту в Чистилке
export const overquotaCleanerBanner: FeatureProps | undefined = getFeature('overquota-cleaner-ab-banner');
